export default __webpack_public_path__ + "static/media/129.e3b70366.webp";